export class DiaballikFailure {
    static CANNOT_MOVE_WITH_BALL = () => $localize `You cannot move the piece holding the ball.`;
    static MUST_MOVE_BY_ONE_ORTHOGONAL_SPACE = () => $localize `You must move by exactly one orthogonal space.`;
    static PASS_PATH_OBSTRUCTED = () => $localize `The path of this pass is obstructed.`;
    static PASS_MUST_BE_IN_STRAIGHT_LINE = () => $localize `A pass must be done in a straight line, orthogonally or diagonally.`;
    static CAN_ONLY_DO_ONE_PASS = () => $localize `You can only perform one pass per turn.`;
    static CAN_ONLY_TRANSLATE_TWICE = () => $localize `You can only perform two translations per turn, not three.`;
    static CANNOT_PASS_TO_OPPONENT = () => $localize `You cannot pass the ball to the opponent. You must pick one of your pieces.`;
}
